import { NgClass, DecimalPipe, CurrencyPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CoinflipDepositModalComponent } from '../../coinflip-deposit-modal/coinflip-deposit-modal.component';
import { CoinflipService } from '../../coinflip.service';
import { ModalService } from '@app/modal/modal.service';
import { NotificationService } from '@app/notification/notification.service';
import { ChatService } from '@features/chat/chat.service';
import { COINFLIP_SIDE_BLUE, COINFLIP_SIDE_RED, Coinflip, CoinflipSide } from '@models/coinflip.interface';
import { CoinflipCoinComponent } from '@shared/coinflip-coin/coinflip-coin.component';
import { CurrencyComponent } from '@shared/currency/currency.component';
import { ToggleUserActionsDirective } from '@shared/directives/toggle-user-actions.directive';
import { IconComponent } from '@shared/icon/icon.component';
import { ItemListComponent } from '@shared/item-list/item-list.component';
import { LevelNewComponent } from '@shared/level-new/level-new.component';
import { NamePipe } from '@shared/pipes/name.pipe';
import { SessionService } from '@shared/session.service';
import { UIService } from '@shared/ui.service';

@Component({
  selector: 'app-coinflip-modal-user',
  templateUrl: './coinflip-modal-user.component.html',
  styleUrls: ['./coinflip-modal-user.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.lost]': '(coinflip?.winner && (coinflip?.winner?.side !== bet?.side)) && (!showAnimation  && coinflip.revealed)',
  },
  imports: [
    ToggleUserActionsDirective,
    CoinflipCoinComponent,
    NgClass,
    LevelNewComponent,
    IconComponent,
    CurrencyComponent,
    ItemListComponent,
    DecimalPipe,
    CurrencyPipe,
    NamePipe,
  ],
})
export class CoinflipModalUserComponent {
  @Input() bet: CoinflipSide;
  @Input() coinflip: Coinflip;
  @Input() showAnimation = false;
  readonly blueSide = COINFLIP_SIDE_BLUE;
  readonly redSide = COINFLIP_SIDE_RED;

  constructor(
    public session: SessionService,
    private modalService: ModalService,
    private coinflipService: CoinflipService,
    private notificationsService: NotificationService,
    private chatService: ChatService,
    public uiService: UIService,
  ) {}

  join() {
    this.modalService.open(CoinflipDepositModalComponent, { depositType: 'join', coinflip: this.coinflip });
  }

  async callBot() {
    try {
      const message = await this.coinflipService.callBot(this.coinflip);
      this.notificationsService.success(String(message), 'Call Bot');
    } catch {
      // The socket layer already toasts the rejection.
    }
  }

  async shareBattle() {
    await this.chatService.announceGame('coinflip', this.coinflip.gameid.toString());
  }
}
